module.exports = __webpack_public_path__ + "static/4-ecb2736be3715bc958390e45220d1ed4.wav";